import { addDays } from "./add-days";
import { addHours } from "./add-hours";
import { addMinutes } from "./add-minutes";
import { addSeconds } from "./add-seconds";
import { calculateDiffDate } from "./calculate-diff-date";
import { compareDates } from "./compare-dates";
import { convertDateToISO8601Format } from "./convert-date-to-string-with-polish-timezone";
import { convertISO8601DurationToDays } from "./convert-iso8601-duration-to-days";
import { convertStringDateToDate } from "./convert-string-to-date-without-time-zone";
import { daysBetween } from "./days-between";
import { daysToSeconds } from "./days-to-seconds";
import { convertDateToFakeUTC, convertFakeUTCToDate } from "./fake-utc-converters";
import { getISOStringDate } from "./get-iso-string-date";
import { getISOStringTime } from "./get-iso-string-time";
import { isSameDay } from "./is-same-day";
import { convertFromSeconds } from "./iso8601-duration/convert-from-seconds";
import { convertToSeconds } from "./iso8601-duration/convert-to-seconds";
import { extract } from "./iso8601-duration/extract";
import { getFinishDate } from "./iso8601-duration/get-finish-date";
import { minutesBetween } from "./minutes-between";
import { roundDownToFullHour, selectEarlierDate, selectLaterDate, selectLatestFromDates } from "./select-earlier-date";

export * from "./dates-diff.pipe";
export { FakeUTCDate, convertDateStringToFakeUTCDate } from "./fake-utc-converters";
export * from "./iso8601-duration/models";

export const DateUtils = {
    addDays,
    addHours,
    addMinutes,
    addSeconds,
    calculateDiffDate,
    convertDateToISO8601Format,
    convertSecondsToISO8601Duration: convertFromSeconds,
    convertISO8601DurationToSeconds: convertToSeconds,
    convertISO8601DurationToDays,
    extractISO8601Duration: extract,
    convertFakeUTCToDate,
    convertDateToFakeUTC,
    getFinishDateForISO8601Duration: getFinishDate,
    getISOStringDate: getISOStringDate,
    getISOStringTime,
    compareDates,
    selectEarlierDate,
    selectLaterDate,
    selectLatestFromDates,
    convertStringDateToDateWithoutTimeZone: convertStringDateToDate,
    daysBetween: daysBetween,
    daysToSeconds,
    minutesBetween: minutesBetween,
    isSameDay,
    roundDownToFullHour,
};
